import script from "./ChatMessageEditModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ChatMessageEditModal.vue?vue&type=script&setup=true&lang=js"

import "./ChatMessageEditModal.vue?vue&type=style&index=0&id=87f6d60e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-87f6d60e"]])

export default __exports__